<template>
  <div class="order-wrapper primary-disabled">
    <portal target-el="#filter">
      <Breadcrumb
        :isHistoryBack="isHistoryBack"
        :hideBackBtn="hideBackBtn"
        :message="trackDetail.shipmentNumber">
      </Breadcrumb>
    </portal>
    <div v-if="!details.error">
      <div class="loading-app" v-if="isLoading">
        <Spinner />
      </div>

      <Row :gutter="20" class="row-reverse" v-else>
         <Col :xl="6" :lg="6" :md="8">
            <div class="slider-collapse wbview">
              <div class="drawer-header slider-collapse-header"  @click="active = !active">
                <span class="status status-icon status-grey">
                  {{status.name}}
                  <span class="badge" v-if="trackingType && trackingType.iconName">
                    <svgicon :name="trackingType.iconName" width="8" height="8" />
                  </span>
                </span>

                <span class="icon-mv">
                  <svgicon name="icon-add-dark"  v-if="active" width="16" height="16" :original="true"/>
                  <svgicon name="icon-minus-dark" v-else width="16" height="16" :original="true"/>
                </span>
              </div>
              <div class="drawer-body slider-collapse-body" :class="{ showview: active }">
                <ul class="drawer-list">
                  <li v-for="header in trackDetailsConstant" :key="header.id">
                    <label>{{header.title}}</label>
                    <div class="list-content">
                      {{trackDetail[header.column]}}
                      <small
                        v-if="header.subDetail && trackDetail[header.subDetail.column]"
                        :class="header.subDetail.class"
                      >
                      {{trackDetail[header.subDetail.column]}}
                      </small>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col :xl="18" :lg="18" :md="16" >
  <ElTabs class="tab-default">
    <Tab-pane label="Track">
      <div class="tab-content content-scroll-sm">
        <div v-if="trackingType && trackingType.iconName" class="tracking-type-indicator">
          <svgicon :name="trackingType.iconName" width="14" height="14" />
          <span>{{ trackingType.name }} Tracked</span>
        </div>
        <div style="text-align: right; margin-bottom: 10px;">
          <button type="button" @click="handleButtonClick($event)" :disabled="isLoading || mapLoading" class="check-location-btn">
            <span class="refresh-icon" :class="{ spinning: mapLoading }">&#8635;</span>
            {{$t('REFRESH_LATEST_LOCATION')}}
          </button>
        </div>
        <div class="map-tracking">
          <div>
            <div v-if="isLoading || mapLoading" class="center-loader">
              <Spinner />
            </div>
            <span class="status-msg" v-else-if="!this.details || !this.details.pings || !this.details.pings.length">
              <svgicon name="empty-location" width="100%" height="300" :original="true" />
              <p>{{$t('NO_LOCATION_FOUND')}}</p>
            </span>
            <div class="status-msg" v-else-if="!isLoading && !mapLoading">
              <iframe :src="trackUrl" frameborder="0" style="border:0"
                      width="100%" height="450"/>
            </div>
          </div>
        </div>
        <Table :data="stopsData" :stripe="true" class="table-striped bordered mt-20">
          <table-column
            v-for="column in pickDropOffConstants"
            :label="column.title"
            :width="column.width"
            :key="column.id"
          >
            <template slot-scope="scope">
              <span v-if="scope.row[column.label]">{{scope.row[column.label]}}</span>
              <span v-else>-</span>
            </template>
          </table-column>
        </Table>
      </div>
    </Tab-pane>
    <Tab-pane label="Timeline">
      <div class="tab-content content-scroll-sm">
        <div class="status-msg" v-if="!timelineEvent || !timelineEvent.length">
          <span>
            <svgicon name="empty-timeline" width="249" height="176" :original="true" />
            <p>No data found</p>
          </span>
        </div>
        <Row v-else>
          <Col :span="13">
            <Timelineblock
            :timelineEvents="timelineEvent">
          </Timelineblock>
          </Col>
          <Col :span="11">
            <div class="ping-source-notice">
              <svgicon name="icon-info" width="14" height="14" />
              <span>{{ pingSourceNotice }}</span>
            </div>
            <Table
            :data="timelineData"
            :stripe="true"
            :max-height="windowHeight"
            class="table-striped bordered">
              <table-column
                label="Ping Received"
                width="220">
                <template slot-scope="scope">
                  <span>{{scope.row.date}}</span>
                    <Tooltip
                      v-if="scope.row.trackingType && scope.row.trackingType !== details.typeOfTracking"
                      :content="getPingTrackingLabel(scope.row.trackingType)"
                      placement="right">
                      <span class="ping-type">
                        <svgicon :name="getPingTrackingIcon(scope.row.trackingType)" width="12" height="12" />
                      </span>
                    </Tooltip>
                </template>
              </table-column>
              <table-column
                prop="location"
                label="Location">
              </table-column>
            </Table>
          </Col>
        </Row>
      </div>
    </Tab-pane>
  </ElTabs>
</Col>
      </Row>
 
    </div>
    <div v-else class="status-msg">
      <span>
        <svgicon name="empty-timeline" width="249" height="176" :original="true" />
        <p>No data found</p>
      </span>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import {
  pickDropOffConstants,
  timelineConstants,
  trackDetailsConstant,
  trackStatus,
  trackType,
  endTripMessage,
} from '@/constants/trackConstants';
import { getAddress, getLocation, getDistanceRem } from '@common/lib/track';
import {
  formatLastKnownTime,
  getDateDiffInDaysMins,
  formatDetailedTime,
  formatDetailedCommentDate,
  formatDetailedDateTime,
  formatTime,
} from '@/lib/Date';
import moment from 'moment';
import Breadcrumb from '@/components/common/Breadcrumb';
import Timelineblock from '@common/components/Timelineblock';

export default {
  props: ['isOpenLink'],
  components: {
    Breadcrumb,
    Timelineblock,
  },
  data() {
    return {
      trackStatus,
      trackType,
      pickDropOffConstants,
      timelineConstants,
      trackDetailsConstant,
      details: {},
      isHistoryBack: true,
      hideBackBtn: false,
      active: false,
      mapLoading: false,
      autoRefreshTimer: null,
    };    
  },
  async mounted() {
    this.$store.commit('track/initialReset');
    const id = this.$route.query.id;
    const t = this.$route.query.t;
    this.details = await this.$store.dispatch('track/getTripDetails', { id, t, isOpenLink: this.isOpenLink });
    if (this.details && this.details.error) {
      this.$errorMessage({ message: this.details.error });
    }
    if (this.isOpenLink) {
      this.hideBackBtn = true;
    }
    if (this.details && !this.details.error && this.isOpenLink) {
      this.startAutoRefresh();
    }
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  computed: {
    ...mapGetters({
      isLoading: 'track/isLoading',
      configurations: 'app/configurations',
      environmentVariables: 'app/environmentVariables',
    }),
    trackUrl() {
      const tripDetails = {
        locations: this.getLocations(this.details.pings || []),
        destination: this.getLocations(this.details.dropLatLongs || [], this.details.dropLocations, 'destination'),
        source: this.getLocations(this.details.pickupLatLongs || [], this.details.pickupLocations, 'source'),
        haltThreshold: (this.configurations && this.configurations.track_settings
          && this.configurations.track_settings.halt_threshold) || 2,
        // Defaut halt_threshold settings for open link
        // TODO: need to be fixed properly
        mapSettings: this.environmentVariables && this.environmentVariables.map_settings,
        isOpenLink: !!this.isOpenLink,
      };
      
      this.$session.set('mapData', tripDetails);
      return `${window.location.origin}/track/map`;
    },
    windowHeight() {
      return `${window.innerHeight - 210}px`;
    },
    status() {
      return this.trackStatus.find(val => val.value === this.details.status);
    },
    trackingType() {
      return this.trackType.find(val => val.value === this.details.typeOfTracking);
    },
    pingSourceNotice() {
      const currentType = this.trackingType;
      const currentValue = currentType && currentType.value;
      const currentName = currentType ? currentType.name : 'APP';
      const otherTypes = this.trackType
        .filter(t => t.value && t.value !== currentValue)
        .map(t => t.name)
        .join(', ');
      return `Pings are ${currentName}-tracked by default.${otherTypes ? ` ${otherTypes} icons indicate pings sourced from network or satellite tracking.` : ''}`;
    },
    timelineData() {
      const timelineData = [];
      if (this.details && this.details.pings) {
        this.details.pings.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        this.details.pings.forEach((val) => {
          const obj = {
            date: formatDetailedDateTime(val.created_at),
            location: val.address || val.city,
            trackingType: val.trackingType || '-',
          };
          timelineData.push(obj);
        });
      }
      return timelineData;
    },
    stopsData() {
      const stopsArray = [];
      if (this.details && this.details.pickupLocations && ((!this.isOpenLink && !(this.configurations.track_settings
        && this.configurations.track_settings.hide_pickup_from_track)) || this.isOpenLink)) {
        this.details.pickupLocations.forEach((val) => {
          const obj = {
            stopType: 'Pickup',
            location: getLocation(val.address),
            estimatedArrival: formatDetailedTime(val.estimatedArrival),
            plannedArrival: formatDetailedTime(val.plannedArrival),
            distanceRemained: getDistanceRem(val.distanceRemained),
          };
          stopsArray.push(obj);
        });
      }
      if (this.details && this.details.dropLocations) {
        this.details.dropLocations.forEach((val) => {
          const obj = {
            stopType: 'Drop Off',
            location: getLocation(val.address),
            estimatedArrival: formatDetailedTime(val.estimatedArrival),
            plannedArrival: formatDetailedTime(val.plannedArrival),
            distanceRemained: getDistanceRem(val.distanceRemained),
          };
          stopsArray.push(obj);
        });
      }
      return stopsArray;
    },
    trackDetail() {
      const obj = {
        shipmentNumber: this.details.shipmentNumber,
        transporterName: this.details.transporterName,
        eta: formatDetailedTime(this.details.plannedEta),
        createdAt: formatDetailedTime(this.details.createdAt),
        driverNumber: this.details.driverPhoneNumber,
        driverName: this.details.driverName,
        status: this.status,
        truckNumber: this.details.truck_number,
        isGpsEnabled: (this.details.typeOfTracking === 'GPS') ? 'GPS ENABLED' : '',
      };
      if (this.details.firstPickup && this.details.firstPickup.address) {
        obj.source = this.details.firstPickup.address.name;
        obj.sourceAddress = getAddress(this.details.firstPickup.address);
      }
      if (this.details.lastDrop && this.details.lastDrop.address) {
        const dropForDestination = (this.isOpenLink && this.details.dropLocations && this.details.dropLocations.length === 1)
          ? this.details.dropLocations[0] : this.details.lastDrop;
        obj.destination = dropForDestination.address.name;
        obj.destinationAddress = getAddress(dropForDestination.address);
        const actualEtaAvl = (this.details.actualEta && this.details.actualEta !== 'NA');
        obj.actualEta = actualEtaAvl ? formatDetailedTime(this.details.actualEta) : '-';
        const etaDiff = actualEtaAvl && getDateDiffInDaysMins(this.details.actualEta, moment());
        obj.etaDetail = this.status &&
          !this.status.excludeEta ? etaDiff && etaDiff.formatted : null;
      }
      if (this.details.latestLocation) {
        obj.lastKnownPlace = this.details.latestLocation &&
          (this.details.latestLocation.city || this.details.latestLocation.address);
        obj.lastKnownTime = formatLastKnownTime(
          this.details.latestLocation.timeStamp,
        );
      }
      return obj;
    },
    timelineEvent() {
      let timelineData = [];

      timelineData = timelineData.concat(this.getTimelineData(this.details.pickupLocations, 'pickup'));
      timelineData = timelineData.concat(this.getTimelineData(this.details.dropLocations, 'drop'));

      if (this.details.endTripDetails) {
        for (let i = 0; i < this.details.endTripDetails.length; i += 1) {
          const endTripDetail = this.details.endTripDetails[i];
          const endTripReason = endTripMessage.find(reason =>
            reason.id === endTripDetail.reason);
          if (endTripReason && endTripReason.show) {
            let orderNo = 'NA';
            if (this.details.customerReferenceMap[endTripDetail.customerReference]) {
              orderNo = endTripDetail.customerReference;
            }
            const actor = (this.details.entityType && this.details.entityType !== 'NA' ? this.details.entityType : 'System');
            const newMessage = endTripReason.message
              .replace('{actor}', actor)
              .replace('#customerReference#', orderNo);
            const tripEndEvent = {
              timestamp: new Date(endTripDetail.timestamp),
              message: 'Trip completed',
              description: newMessage,
            };
            timelineData.push(tripEndEvent);
          }
        }
      }
      if (this.details.midwayChangeData) {
        const midwayChangeData = this.details.midwayChangeData;
        midwayChangeData.sort((a, b) => a.timestamp - b.timestamp);
        midwayChangeData.forEach((data) => {
          if (data.delta) {
            if (this.details.typeOfTracking === 'SIM') {
              const changedData = data.delta.driverPhoneNumber;
              if (changedData) {
                const obj = {
                  timestamp: new Date(data.timestamp),
                  message: 'Driver Phone Number Changed',
                  description: `Driver phone number changed from ${changedData[0]} to ${changedData[1]}`,
                };
                timelineData.push(obj);
              }
            } else {
              // For GPS/APP/other trips - handle vehicle changes
              const vehicleChanged = data.delta.vehicleNumber;
              if (vehicleChanged) {
                const obj = {
                  timestamp: new Date(data.timestamp),
                  message: 'Vehicle Number Changed',
                  description: `Vehicle number changed from ${vehicleChanged[0]} to ${vehicleChanged[1]}`,
                };
                timelineData.push(obj);
              }

              // Handle phone changes when secondary SIM tracking exists
              const phoneChanged = data.delta.driverPhoneNumber;
              if (phoneChanged) {
                const obj = {
                  timestamp: new Date(data.timestamp),
                  message: 'Driver Phone Number Changed',
                  description: `Driver phone number changed from ${phoneChanged[0]} to ${phoneChanged[1]}`,
                };
                timelineData.push(obj);
              }

              // Show when secondary SIM tracking is added (GPS → SIM fallback)
              const secondaryTrackingChanged = data.delta.secondaryTrackingType;
              if (secondaryTrackingChanged && secondaryTrackingChanged[1] === 'SIM') {
                const obj = {
                  timestamp: new Date(data.timestamp),
                  message: 'Fallback Tracking Enabled',
                  description: 'SIM-based tracking activated as secondary tracking',
                };
                timelineData.push(obj);
              }
            }
          }
        });
      }
      if (this.details.tripHalts) {
        const tripHaltData = this.details.tripHalts;
        tripHaltData.sort((a, b) => a.endedAt - b.endedAt);
        tripHaltData.forEach((data) => {
          const duration = moment.duration(moment(data.endedAt).diff(moment(data.startedAt)));
          const totalMinutes = Number(duration.asMinutes().toFixed(2));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = Math.floor(totalMinutes % 60);
          let timeDescription = hours && `${hours} hours`;
          const minutesDescription = minutes && `${minutes} minutes`;
          if (timeDescription) {
            timeDescription =
              minutesDescription ? `${timeDescription} and ${minutesDescription}` : timeDescription;
          } else {
            timeDescription = minutesDescription;
          }

          const obj = {
            timestamp: new Date(data.endedAt),
            message: 'Vehicle Halt',
            description: `Vehicle Halted at ${formatTime(data.startedAt)} for ${timeDescription}`,
          };
          timelineData.push(obj);
        });
      }
      // Trip created status
      timelineData.push({ message: 'Trip Created', timestamp: new Date(this.details.createdAt) });
      timelineData.sort((a, b) => a.timestamp - b.timestamp);
      return timelineData;
    },
  },
  methods: {
    getPingTrackingIcon(type) {
      const iconMap = { SIM: 'icon-simcard', GPS: 'icon-transit', APP: 'icon-mobile' };
      return iconMap[type] || null;
    },
    getPingTrackingLabel(type) {
      const labelMap = { SIM: 'SIM Tracking', GPS: 'GPS Tracking', APP: 'App Tracking' };
      return labelMap[type] || type;
    },
    async handleButtonClick(event) {
      await this.refreshLocation();
    },
    async refreshLocation() {
      if (this.isLoading || this.mapLoading) return;
      if (['COMPLETED', 'CANCELLED', 'INVALID', 'AUTO COMPLETED'].includes(this.details.status)) {
        this.stopAutoRefresh();
        return;
      }
      this.mapLoading = true;
      const id = this.$route.query.id;
      const t = this.$route.query.t;
      const response = await this.$store.dispatch('track/getShipmentTrackLocations', { id, t, isOpenLink: this.isOpenLink });
      if (response) {
        this.$set(this.details, 'pings', response.pings);
        if (response.latestLocation) {
          this.$set(this.details, 'latestLocation', response.latestLocation);
        }
        if (response.dropLocations) {
          this.$set(this.details, 'dropLocations', response.dropLocations);
        }
        if (response.pickupLocations) {
          this.$set(this.details, 'pickupLocations', response.pickupLocations);
        }
        if (response.actualEta) {
          this.$set(this.details, 'actualEta', response.actualEta);
        }
        if (response.status) {
          this.$set(this.details, 'status', response.status);
        }
      }
      this.mapLoading = false;
    },
    startAutoRefresh() {
      this.stopAutoRefresh();
      this.autoRefreshTimer = setInterval(this.refreshLocation, 30000);
    },
    stopAutoRefresh() {
      if (this.autoRefreshTimer) {
        clearInterval(this.autoRefreshTimer);
        this.autoRefreshTimer = null;
      }
    },
    getTimelineData(locations, type) {
      const timelineData = [];
      if (locations) {
        locations.forEach((location) => {
          if (location.timelineData) {
            const entryData = location.timelineData.find(value => value.movementType === 'entry');
            const exitData = location.timelineData.find(value => value.movementType === 'exit');
            if (entryData) {
              const obj = {
                orderOfLocation: location.orderOfLocation,
                timestamp: new Date(entryData.time),
                message: (type === 'pickup') ? 'At Pickup' : 'Reached Destination',
                description: `Vehicle at ${location.address.name}`,
                ...(type === 'drop') ? { type: 'destination' } : {},
              };
              timelineData.push(obj);
            }
            if (exitData) {
              const obj = {
                orderOfLocation: location.orderOfLocation,
                timestamp: new Date(exitData.time),
                message: (type === 'pickup') ? 'Departed from pickup' : 'Released from destination',
                description: `Vehicle left ${location.address.name}`,
              };
              timelineData.push(obj);
            }
          }
        });
      }
      return timelineData;
    },
    getLocations(arr, details = [], markerValue = null) {
      const locations = [];
      arr && arr.forEach((val, index) => {
        let obj = {};
        if (markerValue) {
          // assuming the index of latlong array and location details array match
          const title = (details && details[0]) &&
            details[index].address.name;
          obj[markerValue] = title;
        }
        obj = Object.assign(obj, {
          lat: val.lat,
          lon: val.lon,
          createdAt: val.created_at,
          trackingType: val.trackingType || null,
          address: val.address || val.city || null,
          formattedDate: val.created_at ? formatDetailedCommentDate(val.created_at) : null,
        });
        locations.push(obj);
      });
      return locations;
    },
  },
};
</script>

<style scoped>
.check-location-btn {
  padding: 10px 20px;
  background-color: #007fea;
  font-size: 1.4rem;
  color: white;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.check-location-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.refresh-icon {
  font-size: 1.6rem;
  display: inline-block;
  line-height: 1;
}
.refresh-icon.spinning {
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.center-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 450px;
}
.ping-source-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #444;
  background-color: #e8f1fb;
  border-radius: 4px;
  padding: 10px 12px;
  line-height: 1.5;
}
.ping-type {
  margin-left: 10px;
}
</style>